import { makeStyles } from '@material-ui/core/styles';

import { RiRobot2Line } from '@remixicon/react';

import { Text } from '@backstage/ui';

import {
  type ToolGroupEntry,
  createToolExtension,
  isSubagentTool,
  parseChildChatName,
  useChatRef,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

const useStyles = makeStyles({
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  root: {
    alignItems: 'center',
    animation: '$fadeIn 500ms ease-in',
    display: 'flex',
    gap: 'var(--bui-space-2)',
  },
  icon: {
    color: 'var(--bui-fg-secondary)',
    flexShrink: 0,
  },
});

const CreateSubagentToolRenderer = ({ entry }: { entry: ToolGroupEntry }) => {
  const classes = useStyles();
  const childChatName = parseChildChatName(entry.result?.content);
  const { chat } = useChatRef({
    name: childChatName ?? '',
    skip: !childChatName,
  });
  const displayName = chat?.displayName;
  const label = displayName ?? 'Start subagent';

  return (
    <div className={classes.root}>
      <RiRobot2Line size={14} className={classes.icon} />
      <Text variant="body-small" color="secondary">
        {label}
      </Text>
    </div>
  );
};

export const CreateSubagentToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-subagent',
    predicate: isSubagentTool,
    icon: RiRobot2Line,
    display: 'prominent',
    render: () => null,
    renderTool: entry => <CreateSubagentToolRenderer entry={entry} />,
  }),
);
